export default {
  areFeesIncludingVAT: 'האם העמלות כוללות מע״מ',
};
